import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

const borderColor = (props) => props.theme.global.colors['border-1']
const lightColor = (props) => props.theme.global.colors['white']
const darkColor = (props) => props.theme.global.colors['dark-2']
const pageWidth = (props) => props.theme.global.size.pageWidth

export const RMADetailWrapperWMO = styled(Box)`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  max-width: ${pageWidth};
  margin: 0px auto;
  min-width: 0;
  min-height: 0;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  padding: 0 40px;
  
  @media only screen and (max-width: 992px) {
    margin: 0px auto 24px;
    padding: 0 16px;
  }
`

export const RMADetailBoxWMO = styled(Box)`
  display: flex;
  box-sizing: border-box;
  max-width: 100%;
  margin: 24px auto;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  width: 1360px;
  padding: ${props => props.showTabs ? '24px' : '0'};
  border: ${props => props.showTabs ? `1px solid ${borderColor}`: 'none'};
  border-radius: 4px;
  background-color: ${props => props.showTabs ? lightColor: 'transparent'};

  @media only screen and (max-width: 768px) {
    padding: ${props => props.showTabs ? '16px' : '0'};
    margin:  ${props => props.showTabs ? '0px auto' : '24px auto'}
  }
`

export const DoneReturnBoxWMO = styled(Box)`
  box-sizing: border-box;
  max-width: 100%;
  width: 1360px;
  margin: 32px auto 24px;
  min-width: 0;
  min-height: 0;
  background-color: transparent;

  @media only screen and (max-width: 768px) {
    padding: 16px;
    margin: 0px auto;
  }
`

export const Heading = styled.h1`
  box-sizing: border-box;
  max-width: 100%;
  width: 1360px;
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  color: ${darkColor};
  margin: 32px auto 0;

  @media only screen and (max-width: 768px) {
    font-size: 20px;
    margin: 16px auto;
  }
`

export const ReturnConfirmationHeading = styled.h1`
  box-sizing: border-box;
  max-width: 100%;
  width: 1360px;
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  color: ${darkColor};
  margin: 0 auto 24px;

  @media only screen and (max-width: 768px) {
    font-size: 20px;
    margin: 0 auto 16px;
  }
`